'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemRemote = exports.ItemRemote = {
    fetchBuyNowsByIds: function fetchBuyNowsByIds(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            itemIds = _ref.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>buy-nows' });
            request.send({ itemIds: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchItemsByIds: function fetchItemsByIds(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            itemIds = _ref2.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/items' });
            request.send({ ids: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchItemShippingsByIds: function fetchItemShippingsByIds(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            itemIds = _ref3.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>item-shippings' });
            request.send({ itemIds: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchListingAgentsByIds: function fetchListingAgentsByIds(_ref4) {
        var agentIds = _ref4.agentIds,
            authToken = _ref4.authToken,
            deployment = _ref4.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>listing-agents' });
            request.send({ agentIds: agentIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/item.js
// module id = B1jV
// module chunks = 60